import React, { useState, useEffect, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { ButtonHLPure, DialogWarningGL, DialogSystemGLPure } from '../../pures';
import "./signature-request-profile-document.css";
import { b64toBlob } from "./../../../validators";
import PdfViewerAction from '../../actions/pdf-viewer/pdf-viewer.action';
import SiganturePackageRequestProfileView from "../signature-request-profile-data/signature-package-request-profile.view";

const SignatureRequestProfileDocumentView = (props) => {
  const { t } = useTranslation();
  const { step, onHandleBack, onHandleNext, signatureProfileSelected } = props;
  const { next, back } = step;
  const [blobUrl, setBlobUrl] = useState("");
  const [currentSystem, setCurrentSystem] = useState("");
  const [modalTermsCond, setModalTermsCond] = useState(null);
  const [selectedFileBase64, setSelectedFileBase64] = useState('')
  const [urlPdf, setUrlPdf] = useState('')
  const [acceptDocumentError, setAcceptDocumentError] = useState(false)
  const [modalWarningOpen, setModalWarningOpen] = useState(false)
  const [missingFields, setMissingFields] = useState([])
  const [errorCurrentNameSignature, setErrorCurrentNameSignature] = useState(false)
  const [uploadDocumentError, setUploadDocumentError] = useState(false)
  const [openInvalidFileModal, setOpenInvalidFileModal] = useState(false)
  const [openMissingDocumentsModal, setOpenMissingDocumentsModal] = useState(false)

  const pdf = useMemo(() => {
    const pdfUrl = selectedFileBase64 ? `data:application/pdf;base64,${selectedFileBase64}` : ''
    return <PdfViewerAction url={pdfUrl} isExtended={false} isSSRActive={false} />
  }, [selectedFileBase64])

  const pdfContractnegotiation = useMemo(() => <PdfViewerAction url={urlPdf} isExtended={false} isSSRActive={false} />, [urlPdf])

  useEffect(() => {
    setCurrentSystem(navigator.userAgent);
  }, []);

  let infodevice = currentSystem.toLowerCase();
  let isMobile = infodevice.includes("android");
  isMobile = isMobile || infodevice.includes("iphone");
  isMobile = isMobile || infodevice.includes("ipad");
  isMobile = isMobile || infodevice.includes("mobile");

  const titleDialog = t('signaturePackageRequestProfileView.modal.title.required')
  const widthDialog = isMobile ? 300 : 400
  const heightDialog = isMobile ? 295 : 27

  function isTouchScreendevice() {
    return "ontouchstart" in window || navigator.maxTouchPoints;
  }

  if (isTouchScreendevice()) {
    isMobile = true;
  }

  useEffect(() => {
    if (props.selectedFileBase64 && !props.isContractFromNegotiation) {
      const blob = b64toBlob(props.selectedFileBase64, "application/pdf");
      setBlobUrl(blob);
      setSelectedFileBase64(props.selectedFileBase64)
    }
  }, [props.selectedFileBase64]);

  useEffect(() => {
    if (props.contractFromNegotiation && props.contractFromNegotiation.url) {
      setUrlPdf(props.contractFromNegotiation.url)
    }
  }, [props.contractFromNegotiation])



  const onHandleSubmit = () => {
    if (props.nameSignature) {
      if (props.nameSignature && typeof props.onChangeNameSignature === 'function') {
        const syntheticEvent = { target: { value: props.nameSignature } }
        props.onChangeNameSignature(syntheticEvent)
      }
    }

    const isVentoPackage = (
      (props.profilesDocuments && Array.isArray(props.profilesDocuments) && props.profilesDocuments.length > 0) ||
      (props.signatureProfileSelected && props.signatureProfileSelected.documentProfile) ||
      (props.documentProfile && props.documentProfile.length > 0)
    )

    if (isVentoPackage) {

      const documentsWithContent = props.profilesDocuments?.filter(doc => {
        const hasDocument = doc.document && (doc.document.name || doc.document.size || doc.documentName)
        const hasUpload = doc.upload
        return hasDocument && hasUpload
      }) || []

      if (documentsWithContent.length === 0) {
        setOpenMissingDocumentsModal(true)
        return
      }

      const totalDocs = props.profilesDocuments?.length || 0
      const allDocumentsUploaded = documentsWithContent.length === totalDocs
      if (!allDocumentsUploaded) {
        setOpenMissingDocumentsModal(true)
        return
      }
    }

    // const hasInvalidFilename = validateFilenamesOnSubmit()
    // if (hasInvalidFilename) {
    //   setOpenInvalidFileModal(true)
    //   return
    // }

    const missing = validateRequiredFields()
    const hasNameSignature = props.nameSignature && props.nameSignature.trim() !== ""

    setErrorCurrentNameSignature(!hasNameSignature)

    const isVentoPackageCheck = (
      (props.profilesDocuments && Array.isArray(props.profilesDocuments) && props.profilesDocuments.length > 0) ||
      (props.signatureProfileSelected && props.signatureProfileSelected.documentProfile) ||
      (props.documentProfile && props.documentProfile.length > 0)
    )

    if (!isVentoPackageCheck) {
      const hasDocument = props.selectedFileBase64 && props.selectedFileBase64.trim() !== ''
      setUploadDocumentError(!hasDocument)
    }

    if (!props.documentAccept) {
      setAcceptDocumentError(true)
    }

    if (missing.length > 0) {
      setMissingFields(missing)
      setModalWarningOpen(true)
      return
    }

    const isValid = props.onValidateProfileData()
    if (isValid) onHandleNext()
  }

  const onChangeCheckboxHandler = (e) => {
    if (acceptDocumentError) setAcceptDocumentError(false)
    props.handleChangeCheckbox(e)
  }

  const validateRequiredFields = () => {
    const missing = []

    if (!props.nameSignature || props.nameSignature.trim() === '') {
      missing.push(t('signatureRequestProfileDocumentView.requestName'))
    }

    const isVentoPackage = props.profilesDocuments && props.profilesDocuments.length > 0
    if (!isVentoPackage) {
      let hasDocument = false
      if (props.selectedFileBase64) {
        hasDocument = true
      }

      if (!hasDocument) {
        missing.push(t('signatureRequestProfileDocumentView.uploadDocument'))
      }
    }

    if (!props.documentAccept) {
      missing.push(t('signatureRequestProfileDocumentView.documentVerification'))
    }

    return missing
  }

  const onChangeNameSignature = (e) => {
    if (errorCurrentNameSignature) {
      setErrorCurrentNameSignature(false)
    }
    props.onChangeNameSignature(e)
  }

  const onHandleFileUpload = () => {
    if (uploadDocumentError) {
      setUploadDocumentError(false)
    }
  }

  const formatMissingFieldsMessage = (missingFields) => {
    if (missingFields.length === 0) return ''

    if (missingFields.length === 1) {
      return `${missingFields[0]}`
    }

    const allButLast = missingFields.slice(0, -1).join(', ')
    const last = missingFields[missingFields.length - 1]
    return `${allButLast}${t('signatureRequestProfileDocumentView.validation.text')} ${last}`
  }

  const messageWarning = `${t('signaturePackageRequestProfileView.modal.description.warning')}`


  return (
    <div className={"step-card-SiganturePackageRequestProfileView"}>
      <SiganturePackageRequestProfileView
        {...props}
        acceptDocumentError={acceptDocumentError}
        handleChangeCheckbox={onChangeCheckboxHandler}
        open={modalWarningOpen}
        onClose={() => setModalWarningOpen(false)}
        missingFields={missingFields}
        errorCurrentNameSignature={errorCurrentNameSignature}
        onChangeNameSignature={onChangeNameSignature}
        uploadDocumentError={uploadDocumentError}
        onHandleFileUpload={onHandleFileUpload}
      />
      <DialogSystemGLPure
        isWarnign={modalWarningOpen}
        messageWarning={messageWarning}
        showBtnSubmitWarning={false}
        showBtnCancelWarning={true}
        handleWarningClose={() => setModalWarningOpen(false)}
        handleWarningSubmit={() => setModalWarningOpen(false)}
        labelWarningBtnCancel={t('button.close')}
        heightDialog={heightDialog}
        widthDialog={widthDialog}
        titleDialog={titleDialog}
      />

      <DialogSystemGLPure
        isWarnign={openInvalidFileModal}
        messageWarning={t('signaturePackageRequestProfileView.modal.description.invalid.file')}
        showBtnSubmitWarning={false}
        showBtnCancelWarning={true}
        handleWarningClose={() => setOpenInvalidFileModal(false)}
        handleWarningSubmit={() => setOpenInvalidFileModal(false)}
        labelWarningBtnCancel={t('button.close')}
        heightDialog={heightDialog}
        widthDialog={widthDialog}
        titleDialog={t('signaturePackageRequestProfileView.modal.title.invalid.file')}
      />

      <DialogSystemGLPure
        isWarnign={openMissingDocumentsModal}
        messageWarning={t('signaturePackageRequestProfileView.modal.description.missing.documents')}
        showBtnSubmitWarning={false}
        showBtnCancelWarning={true}
        handleWarningClose={() => setOpenMissingDocumentsModal(false)}
        handleWarningSubmit={() => setOpenMissingDocumentsModal(false)}
        labelWarningBtnCancel={t('button.close')}
        heightDialog={heightDialog}
        widthDialog={widthDialog}
        titleDialog={t('signaturePackageRequestProfileView.modal.title.missing.documents')}
      />

      <div className="action-buttons">
        <ButtonHLPure
          nameBtn={back}
          onClickBtn={onHandleBack}
        />
        <ButtonHLPure
          nameBtn={next}
          primary
          onClickBtn={onHandleSubmit}
        />
      </div>
    </div>
  );
};

export default SignatureRequestProfileDocumentView;
